module.exports = __webpack_public_path__ + "img/next2.7c6f6db7.svg";